import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';

import Imagem from 'Component/Imagem';
import VinculoEmpregaticio from 'Interface/VinculosEmpregaticios';

interface Props {
  dados: VinculoEmpregaticio;
}

const AniversarioLista = ({ dados }: Props): React.ReactElement => {
  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <Imagem
        src={dados.usuario?.imagem}
        alt={dados.usuario?.nome}
        className="rounded-circle object-fit-cover"
        width="80"
        height="80"
      />
      <div className="ms-4 fs-4" style={{ flex: 2 }}>
        {dados.usuario?.nome}
        <small className="d-block fs-6 text-muted">{dados.usuario?.email}</small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end" style={{ flex: 1 }}>
        <div className="ms-5 fs-5 text-end" style={{ flex: 1 }}>
          {Math.abs(dados.admissao.data().diff(DateTime.now(), 'years').toObject().years || 0).toFixed(0)}
          <small className="d-block fs-6 text-muted">Tempo empresa</small>
        </div>
        <div className="ms-5 fs-5 text-end" style={{ flex: 1 }}>
          {dados.admissao.data().toFormat('dd/MM')}
          <small className="d-block fs-6 text-muted">Aniversário empresa</small>
        </div>
      </BrowserView>
    </div>
  );
};

export default AniversarioLista;
